import React, { useEffect, useMemo, useState } from 'react';
import RecipeInsightModalMobile from './RecipeInsightModalMobile';
import RecipeInsightModalDesktop from './RecipeInsightModalDesktop';
import useRecipeInsightData from '../hooks/useRecipeInsightData';

const MOBILE_BREAKPOINT_PX = 1024;

const getIsMobile = () => {
  if (typeof window === 'undefined') return false;
  return window.innerWidth < MOBILE_BREAKPOINT_PX;
};

export default function RecipeInsightModal(props) {
  const { recipe, userProfile } = props;
  const [isMobile, setIsMobile] = useState(getIsMobile);
  const insightData = useRecipeInsightData({ recipe, userProfile });

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;
    const onResize = () => setIsMobile(getIsMobile());
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const forwardedProps = useMemo(
    () => ({
      ...props,
      recipe: {
        ...(recipe || {}),
        insight: insightData
      }
    }),
    [insightData, props, recipe]
  );

  if (isMobile) {
    return <RecipeInsightModalMobile {...forwardedProps} />;
  }

  return <RecipeInsightModalDesktop {...forwardedProps} />;
}
